//@ts-strict-ignore
import React, { Component } from 'react';
import InputBlock from '../../components/connectedForm/InputBlock';
import InputGroup from '../../components/connectedForm/InputGroup';
import InputLabel, { IInputLabelProps } from './InputLabel';
import Value from '../../components/connectedForm/Value';
import ICommonFieldProps from '../../@types/ICommonFieldProps';
import { IValueProps } from './Value/Value';

export type IValueFieldProps = ICommonFieldProps &
  IInputLabelProps &
  IValueProps & {
    hideField?: string;
    value: string | number;
    inGrid?: boolean;
    datatype?: 'numeric' | undefined;
    textAlign?: string;
    currency?: boolean;
    decimals?: number;
    link?: boolean;
  };

export default class ValueField extends Component<IValueFieldProps, { error: any; errorInfo: any }> {
  private node: any;
  static defaultProps: {
    iconSuffix: boolean;
    onChange: () => void;
    labelCols: number;
    includeLabel: boolean;
    inputCols: number;
    label: string;
    id: string;
    bold: boolean;
    value: string;
    inputPrefix: null;
    flexBox: boolean;
  };

  focus() {
    this.node.focus();
  }

  render() {
    const {
      alignLabel,
      bold,
      id,
      label,
      includeLabel,
      flexBox,
      labelCols,
      labelAddon,
      inputCols,
      hideField,
      view,
      uppercaseLabel,
      reformatLabel,
    } = this.props;

    const labelProps = {
      bold,
      flexBox,
      id,
      includeLabel,
      label,
      labelAddon,
      view,
      alignLabel,
      uppercaseLabel,
      reformatLabel,
    };

    if (this.props.inGrid) return <Value {...this.props} />;
    return (
      <InputBlock hideField={hideField} flexBox={flexBox}>
        <InputLabel {...labelProps} cols={labelCols} view={view} bold={bold} />
        <InputGroup flexBox={flexBox} cols={includeLabel ? inputCols : 1} withLabel={includeLabel} view={view}>
          <Value {...this.props} />
        </InputGroup>
      </InputBlock>
    );
  }
}

ValueField.defaultProps = {
  onChange: () => {},
  includeLabel: true,
  inputPrefix: null,
  flexBox: true,
  labelCols: 1 / 4,
  inputCols: 3 / 4,
  value: '',
  label: '',
  id: '',
  iconSuffix: false,
  bold: false,
};
